import BaseReducer from "shared/types/baseReducer";
import { Action, ActionType, ReducerDispatch, State } from "./types.d";
import { ApiNonAttendeeRegistrationParticipant } from "shared/components/searchNonAttendeeRegistrationForm/types";

export default class Reducer extends BaseReducer<ActionType> implements ReducerDispatch {
  static reducer(state: State, action: ActionType): State {
    switch (action.type) {
      case Action.SAVE_SEARCHED_NON_ATTENDEE_INFO:
        return {
          ...state,
          step: 1,
          workEmail: action.data.workEmail,
          nonAttendeeParticipant: action.data.nonAttendeeParticipant
        };
      default:
        return {
          step: 0
        };
    }
  }

  public saveSearchedNonAttendeeInfo(workEmail: string, nonAttendeeParticipant: ApiNonAttendeeRegistrationParticipant) {
    return this.dispatch({
      type: Action.SAVE_SEARCHED_NON_ATTENDEE_INFO,
      data: { workEmail, nonAttendeeParticipant }
    });
  }
}
